<div class="page-container">
  <div class="dashboard-header">
    <h1>{{ isEditMode ? 'Editar Cliente' : 'Novo Cliente' }}</h1>
    <button mat-icon-button (click)="voltar()" matTooltip="Voltar" aria-label="Voltar" class="back-button">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>

  <div *ngIf="success" class="alert alert-success" role="alert" aria-live="polite">
    <mat-icon aria-hidden="true">check_circle</mat-icon>
    {{ success }}
  </div>

  <div *ngIf="error" class="alert alert-error" role="alert" aria-live="assertive">
    <mat-icon aria-hidden="true">error</mat-icon>
    {{ error }}
  </div>

  <form (ngSubmit)="onSubmit()" class="form-container">
    <!-- Dados Básicos -->
    <mat-card class="form-section">
      <mat-card-title>Dados Básicos</mat-card-title>
      <mat-card-content>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Nome Completo *</mat-label>
            <input matInput type="text" name="nome" [(ngModel)]="pessoa.nome" placeholder="Digite o nome completo"
              required [disabled]="loading" maxlength="80" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>CPF/CNPJ *</mat-label>
            <input matInput type="text" name="documento" [(ngModel)]="pessoa.documento" placeholder="00000000000"
              required [disabled]="loading" (input)="onlyNumbers($event, 'documento')" />
            <mat-hint>Apenas números</mat-hint>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Contato -->
    <mat-card class="form-section" *ngIf="!isEditMode">
      <mat-card-title>Contato</mat-card-title>
      <mat-card-content>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>DDD</mat-label>
            <input matInput type="text" name="ddd" [(ngModel)]="contato.ddd" placeholder="11" maxlength="2"
              [disabled]="loading" (input)="onlyNumbers($event, 'ddd')" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Celular</mat-label>
            <input matInput type="text" name="celular" [(ngModel)]="contato.celular" placeholder="912345678"
              [disabled]="loading" (input)="onlyNumbers($event, 'celular')" />
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>E-mail</mat-label>
            <input matInput type="email" name="email" [(ngModel)]="contato.email" placeholder="email@exemplo.com"
              [disabled]="loading" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Facebook / Instagram</mat-label>
            <input matInput type="text" name="site" [(ngModel)]="contato.site" placeholder="Facebook / Instagram"
              [disabled]="loading" />
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Contato Adicional -->
    <mat-card class="form-section" *ngIf="!isEditMode">
      <mat-card-title>Contato Adicional</mat-card-title>
      <mat-card-content>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Descrição (Adicional)</mat-label>
            <input matInput type="text" name="descricaoAdic" [(ngModel)]="contato.descricaoAdic" placeholder="Observações do contato adicional"
              [disabled]="loading" />
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>DDD (Adicional)</mat-label>
            <input matInput type="text" name="dddAdic" [(ngModel)]="contato.dddAdic" placeholder="11" maxlength="2"
              [disabled]="loading" (input)="onlyNumbers($event, 'dddAdic')" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Celular (Adicional)</mat-label>
            <input matInput type="text" name="celularAdic" [(ngModel)]="contato.celularAdic" placeholder="912345678"
              [disabled]="loading" (input)="onlyNumbers($event, 'celularAdic')" />
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Endereço -->
    <mat-card class="form-section" *ngIf="!isEditMode">
      <mat-card-title>Endereço</mat-card-title>
      <mat-card-content>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-group-full">
            <mat-label>CEP</mat-label>
            <input matInput type="text" name="cep" [(ngModel)]="endereco.cep" placeholder="00000000"
              [disabled]="loading" (input)="onlyNumbers($event, 'cep')" />
          </mat-form-field>
          <button class="cep-btn" type="button" mat-raised-button color="primary"
            (click)="buscarCep()" [disabled]="loading || loadingCep || !endereco.cep">
            <mat-icon *ngIf="loadingCep">refresh</mat-icon>
            {{ loadingCep ? 'Buscando...' : 'Buscar CEP' }}
          </button>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Logradouro</mat-label>
            <input matInput type="text" name="logradouro" [(ngModel)]="endereco.logradouro"
              placeholder="Rua, Avenida, etc." [disabled]="loading" />
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-group-full">
            <mat-label>Número</mat-label>
            <input matInput type="text" name="numero" [(ngModel)]="endereco.numrero" placeholder="Nº"
              [disabled]="loading" (input)="onlyNumbers($event, 'numero')" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Complemento</mat-label>
            <input matInput type="text" name="complemento" [(ngModel)]="endereco.complemento"
              placeholder="Apto, Bloco, etc." [disabled]="loading" />
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Bairro</mat-label>
            <input matInput type="text" name="bairro" [(ngModel)]="endereco.bairro" placeholder="Bairro"
              [disabled]="loading" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Cidade</mat-label>
            <input matInput type="text" name="cidade" [(ngModel)]="endereco.cidade" placeholder="Cidade"
              [disabled]="loading" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-group">
            <mat-label>Estado</mat-label>
            <input matInput type="text" name="uf" [(ngModel)]="endereco.uf" placeholder="UF" maxlength="2"
              [disabled]="loading" />
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Upload de Arquivo -->
    <mat-card class="form-section" *ngIf="!isEditMode">
      <mat-card-title>Anexar Documento ou Imagem</mat-card-title>
      <mat-card-content>
        <div class="form-row">
          <div class="file-upload-container form-group">
            <input type="file" #fileInput (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png"
              class="file-input-hidden" [disabled]="loading" />
            <button type="button" mat-raised-button color="accent" (click)="fileInput.click()" [disabled]="loading">
              <mat-icon>attach_file</mat-icon>
              Selecionar Arquivo
            </button>
            <span class="file-name" *ngIf="selectedFileName">{{ selectedFileName }}</span>
          </div>
        </div>
        <mat-hint class="file-hint">Formatos aceitos: PDF, JPG, JPEG, PNG</mat-hint>
      </mat-card-content>
    </mat-card>

    <!-- Botões -->
    <mat-card class="form-actions">
      <mat-card-content>
        <div class="button-row button-row-end">
          <button type="button" mat-stroked-button (click)="voltar()" [disabled]="loading">
            <mat-icon>cancel</mat-icon>
            Cancelar
          </button>
          <button type="submit" mat-raised-button color="primary" [disabled]="loading">
            <mat-icon *ngIf="loading">refresh</mat-icon>
            <mat-icon *ngIf="!loading">save</mat-icon>
            {{ loading ? 'Salvando...' : (isEditMode ? 'Atualizar Cliente' : 'Salvar Cliente') }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</div>